module.exports = __webpack_public_path__ + "static/media/eventDashboardIcon.3b998c71.svg";